module.exports = __webpack_public_path__ + "static/media/topic.a766911c.svg";